import axios from "axios";

const SUBCONTRACT_URI_PREFIX = "/v1/sub-contractor";
export const SUBCONTRACT_URIS = {
  GET_LIST_SUBCONTRACT: `${SUBCONTRACT_URI_PREFIX}/list`,
  GET_LIST_HISTORY_ALL_SUBCONTRACT: `${SUBCONTRACT_URI_PREFIX}/history`,
  GET_LIST_HISTORY_SUBCONTRACT: (subcontractId) =>
    `${SUBCONTRACT_URI_PREFIX}/history`,
  EXPORT_LIST_SUBCONTRACT: `${SUBCONTRACT_URI_PREFIX}/export`,
  ADD_SUBCONTRACT: `${SUBCONTRACT_URI_PREFIX}/add`,
  EDIT_SUBCONTRACT: `${SUBCONTRACT_URI_PREFIX}/edit`,
  SET_SUBCONTRACT_STATUS: `${SUBCONTRACT_URI_PREFIX}/set-status`,
  GET_SUBCONTRACTOR_BY_ID: (subcontractId) =>
    `${SUBCONTRACT_URI_PREFIX}/${subcontractId}/detail`,
    GET_LIST_IMPORT_CONFIRM: `${SUBCONTRACT_URI_PREFIX}/duplicate`,
  IMPORT_CONTINUE: `${SUBCONTRACT_URI_PREFIX}/continue`,
    GET_LIST_SERVICE_ITEMS: (routeId) => `/v2/bill/service/items/route/${routeId}`,
};

export default {
  getListSubcontractor(params, signal) {
    return axios.get(SUBCONTRACT_URIS.GET_LIST_SUBCONTRACT, { params, signal });
  },
  getListServiceItems(params, signal) {
    const { routeId, projectId } = params;
    return axios.get(SUBCONTRACT_URIS.GET_LIST_SERVICE_ITEMS(routeId), {
      params,
    });
  },
  getHistoryAllSubcontractorr(params) {
    return axios.get(SUBCONTRACT_URIS.GET_LIST_HISTORY_ALL_SUBCONTRACT, {
      params,
    });
  },
  getHistoryOfSubcontractor(params) {
    const { driverId, ...rest } = params;
    return axios.get(SUBCONTRACT_URIS.GET_LIST_HISTORY_SUBCONTRACT(driverId), {
      params: rest,
    });
  },
  exportListSubcontractor(params) {
    const searchParams = new URLSearchParams(params);
    const link = `${
      SUBCONTRACT_URIS.EXPORT_LIST_SUBCONTRACT
    }?${searchParams.toString()}`;
    window.open(link);
  },
  addSubcontractor(data) {
    return axios.post(SUBCONTRACT_URIS.ADD_SUBCONTRACT, {
      ...data,
      lat: 13.7245601,
      lng: 100.4930241,
    });
  },
  editSubcontractor(data) {
    return axios.put(SUBCONTRACT_URIS.EDIT_SUBCONTRACT, data);
  },
  getSubcontractorById(id) {
    return axios.get(SUBCONTRACT_URIS.GET_SUBCONTRACTOR_BY_ID(id));
  },
  setSubcontractorStatus(data) {
    return axios.post(SUBCONTRACT_URIS.SET_SUBCONTRACT_STATUS, data);
  },
  getListConfirmImportSubcontractor(params) {
    return axios.get(SUBCONTRACT_URIS.GET_LIST_IMPORT_CONFIRM, { params });
  },
  importContinueSubcontractor(data) {
    return axios.post(SUBCONTRACT_URIS.IMPORT_CONTINUE, data);
  },
};



// WEBPACK FOOTER //
// ./src/services/subcontract-service.js